export const userResourceForm = {
  name: '',
  path: '',
  category: '',
};
